import { timeFormat } from '@/utils/other';
import BaseListClass from './BaseListClass';
import ListClass from './ListClass';
import RequestApi from './RequestApiClass';

type ISearchPayment = IPayment.IRequest.ISearchPayment;
type IPaymentInfo = IPayment.IResponse.IPaymentInfo;
type IUpdatePaymentData = IPayment.IRequest.IUpdatePaymentData;

interface IGetPaymentParams {
  pageindex: number;
  pagesize: number;
}

const defaultParams: IGetPaymentParams = {
  pageindex: 1,
  pagesize: 100,
};
export default class PaymentListClass extends BaseListClass<IPaymentInfo> {
  public $requestParams: ISearchPayment = {...defaultParams};
  public detailParams: ISearchPayment = {
    returnComment: true,
  };
  constructor() {
    super({
      list: new ListClass<IPaymentInfo>(),
      requestApi: new RequestApi('Payment'),
    });
  }
  public $initRequestParams() {
    this.$requestParams = {...defaultParams};
  }
  public checkItem(payment: IPaymentInfo) {
    const result: boolean[] = [];
    ['id', 'quotationId', 'projectId', 'status'].forEach((key) => {
      if (this.$requestParams[key as keyof ISearchPayment]) {
        result.push(
          payment[key as keyof IPaymentInfo] === this.$requestParams[key as keyof ISearchPayment],
        );
      }
    });
    if (this.$requestParams.title) {
      result.push(payment.title.includes(this.$requestParams.title));
    }
    return result.every((value) => value);
  }
  public convertData(payments: IPaymentInfo[]): IPaymentInfo[] {
    return payments.map((payment) => ({
      ...payment,
      createdOn: timeFormat(payment.createdOn),
    }));
  }
  public createPayment() {
    const newPayment: IUpdatePaymentData = {
      title: '',
      items: [],
      type: 0,
      jsonData: '',
    };
    return newPayment;
  }
}
export const paymentListInstance = new PaymentListClass();
